export default __webpack_public_path__ + "static/media/const8.fcdd9c74.jpg";